<template>
  <div v-bind="$attrs"
       v-on="$listeners"
       :class="$style.text"
       :style="style">
    <slot />
  </div>
</template>

<script>
  import { DefaultPseudoClassAttributeNames,
           DefaultPseudoClassVariableNames,
           getPseudoClassesObject,
           filterObjectByArray} from '@js/vue-style-utils'

  export default {
    name: 'BaseText',
    inheritAttrs: false,
    data: function () {
      return {
        postfixes: ['', 'hover', 'active', 'selected', 'disabled'],
        style: {
          display: 'inline',
        },
      };
    },
    created: function () {
      const classObject = getPseudoClassesObject(
        this.$attrs, DefaultPseudoClassAttributeNames,
        '--base-text-', DefaultPseudoClassVariableNames,
        this.postfixes);
      const attrs = filterObjectByArray(
        this.$attrs, DefaultPseudoClassAttributeNames);

      this.style = {
        ...this.style,
        ...attrs,
        ...classObject,
      };
    },
  };
</script>

<style lang="stylus" module>
  .text
    color var(--base-text-color)
    cursor var(--base-text-dcursor)
    font-family var(--base-text-font-family)
    font-size var(--base-text-font-size)
    font-weight var(--base-text-font-weight)
    line-height var(--base-text-line-height)
    text-decoration var(--base-text-text-decoration)
    &:hover
      color var(--base-text-color-hover)
      cursor var(--base-text-dcursor-hover)
      font-family var(--base-text-font-family-hover)
      font-size var(--base-text-font-size-hover)
      font-weight var(--base-text-font-weight-hover)
      line-height var(--base-text-line-height-hover)
      text-decoration var(--base-text-text-decoration-hover)
    &:active
      color var(--base-text-color-active)
      cursor var(--base-text-dcursor-active)
      font-family var(--base-text-font-family-active)
      font-size var(--base-text-font-size-active)
      font-weight var(--base-text-font-weight-active)
      line-height var(--base-text-line-height-active)
      text-decoration var(--base-text-text-decoration-active)
    &[selected]
      color var(--base-text-color-selected)
      cursor var(--base-text-dcursor-selected)
      font-family var(--base-text-font-family-selected)
      font-size var(--base-text-font-size-selected)
      font-weight var(--base-text-font-weight-selected)
      line-height var(--base-text-line-height-selected)
      text-decoration var(--base-text-text-decoration-selected)
    &[disabled]
      color var(--base-text-color-disabled)
      cursor var(--base-text-dcursor-disabled)
      font-family var(--base-text-font-family-disabled)
      font-size var(--base-text-font-size-disabled)
      font-weight var(--base-text-font-weight-disabled)
      line-height var(--base-text-line-height-disabled)
      text-decoration var(--base-text-text-decoration-disabled)
</style>
